module.exports = __webpack_public_path__ + "static/home-mobile-c80c3660fbb25ae672d6877fb8b4aaa7.png";